import { useEffect, useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Toolbar } from 'primereact/toolbar';
import { DataFlowLetterValidate, LetterShowClick } from '../../../../config/Validate';
import { convertDateFrom, defaultPageRowOptions, defaultRowOptions, SkeletonbodyTemplate, Skeletonitems } from '../../../../appconfig/Settings';
import { getAllDetailsDirect, getSpecificDetailsById, postAllData } from '../../../../service/ProductService';
import { GETDATAFLOWLETTER, STOREDATAFLOWLETTER, DOWNLOADDATAFLOWLETTER } from '../../../../config/ApiConstant';
import { DataFlowListColumns } from '../../../../appconfig/DatatableSetting';
import { amountTemplate, dateTemplate } from '../../../../appconfig/DatatableTemplateSetting';
import { LettersTab } from '../../LettersTab';
import { DataFlowLetterTab } from '../DataFlowLetterTab';
import { Calendar } from 'primereact/calendar';
import Loader from '../../../../components/Loadeer/Loader';

export const DataFlow = () => {
    document.title = 'Data Flow | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(true);
    const [errors, setErrors] = useState<any>({});
    const [regNo, setRegNo] = useState<any>(null);
    const [dataFlowLetterData, setDataFlowLetterData] = useState<any>({
        letter_date: new Date(),
        goodstanding_date: new Date(),
    });
    const [addLoader, setAddLoader] = useState<boolean>(false);
    const [dataFlowLetterList, setDataFlowLetterList] = useState<any>([]);
    const [showLoading, setShowLoading] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [buttonVisible, setButtonVisible] = useState<boolean>(true);

    // useEffect
    useEffect(() => {
        gerDataFlowLetter();
    }, []);

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                <span className="search-bar mr-3">
                    <i className="pi pi-search"></i>
                    <InputText type="search" className="search-input" onInput={(e) => setGlobalFilter(e.currentTarget.value)} placeholder="Search..." />
                </span>
            </>
        );
    };

    // Right toolbar
    const rightToolbarTemplate = () => {
        return (
            <>
                <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAllFilter()} className="p-button-outlined"></Button>
            </>
        );
    };

    //Clear All Filter
    const clearAllFilter = () => {
        setGlobalFieldFilter(null);
        setGlobalFilter(null);
    };

    // Clear all
    const clearAll = () => {
        setRegNo(null);
        setDataFlowLetterData({
            Name: null,
            // ToAddress: null,
            RegNo: '',
            letter_date: new Date(),
            goodstanding_date: new Date()
        });
        setErrors({});
    };

    // gerDataFlowLetter List
    const gerDataFlowLetter = async () => {
        if (!window.cn(regNo)) {
            try {
                setShowLoading(true);

                const response = await getAllDetailsDirect(GETDATAFLOWLETTER + '?RegNo=' + regNo + '&search=' + '');
                const { List } = response;
                if (!window.cn(response) && Object.keys(response?.Details).length !== 0) {
                    const { StudF, StudM, StudL, RegNo, SrNo, LastVDate, RegDt } = response?.Details;

                    let FromNm = (!window.cn(StudL) ? StudL : '') + ' ' + (!window.cn(StudF) ? StudF : '') + ' ' + (!window.cn(StudM) ? StudM : '');
                    setDataFlowLetterData({
                        ...dataFlowLetterData,
                        Name: FromNm,
                        RegNo: RegNo,
                        FileNo: SrNo,
                        reg_date: convertDateFrom(RegDt),
                        validity: convertDateFrom(LastVDate),
                    });
                    setDataFlowLetterList(List);
                    setShowLoading(false);
                    setButtonVisible(false);
                } else {
                    setButtonVisible(true);
                    setShowLoading(false);
                    setDataFlowLetterData({ ...dataFlowLetterData });
                }
            } catch (error: any) {
                if (error.response) {
                    //Spinner False and Set Toast

                    setShowLoading(false);
                    toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
                }
            }
        } else {
            try {
                setPageLoad(false);
                const response = await getAllDetailsDirect(GETDATAFLOWLETTER + '?search=' + '');

                if (response) {
                    const { List } = response;
                    setDataFlowLetterList(List);
                    setPageLoad(true);
                }
            } catch (error: any) {
                if (error.response) {
                    //Spinner False and Set Toast
                    setPageLoad(true);

                    toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
                }
            }
        }
    };

    // onShowClick get User Deatsils
    const getUserDetails = async () => {
        try {
            const { errors, isError } = LetterShowClick(regNo);
            setErrors(errors);

            //Check Error if no errors then call API
            if (!isError) {
                setShowLoading(true);
                gerDataFlowLetter();
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setShowLoading(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
            }
        }
    };

    //onchange event
    const onInputChange = (e: any, name: string) => {
        let val;
        if (name === 'letter_date' || name === 'goodstanding_date') {
            val = e;
        } else {
            val = (e.target && e.target.value) || e.value || '';
        }

        setDataFlowLetterData({ ...dataFlowLetterData, [name]: val });
    };

    // DataFlow Submission
    const addDataFlowLetterData = async () => {
        try {
            const { errors, isError } = DataFlowLetterValidate(dataFlowLetterData, regNo);
            setErrors(errors);

            if (!isError) {
                setAddLoader(true);

                const { Name, RegNo, goodstanding_date, letter_date, FileNo } = dataFlowLetterData;

                // payload
                let requestData = {
                    ...dataFlowLetterData,
                    Name: Name,
                    RegNo: RegNo,
                    FileNo: Number(FileNo),
                    goodstanding_date: convertDateFrom(goodstanding_date),
                    letter_date: convertDateFrom(letter_date),
                };

                // Optional: fallback for empty values
                if (!requestData.Name) requestData.Name = '';
                // if (!requestData.ToAddress) requestData.ToAddress = '';
                if (!requestData.RegNo) requestData.RegNo = regNo;

                // API call
                const response = await postAllData(STOREDATAFLOWLETTER, requestData);

                if (response) {
                    setAddLoader(false);
                    toast.current?.show({ severity: 'success', summary: 'Message', detail: response?.data || 'Saved successfully' });

                    // Reset form after save
                    clearAll();
                    setDataFlowLetterData({
                        letter_date: new Date(),
                        goodstanding_date: new Date(),
                    });
                    gerDataFlowLetter();
                }
            }
        } catch (error: any) {
            console.error("Error while saving:", error);
            setAddLoader(false);
            toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong while saving data' });
        }
    };


    // Template for actions
    const actionsTemplate = (rowData: any) => {
        return (
            <>
                <div className="actions action-btn">
                    <Button icon="pi pi-download" onClick={() => downloadDataFlowLetter(rowData?.id)} tooltip="Download" tooltipOptions={{ position: 'top' }} />
                </div>
            </>
        );
    };

    // Download bank entry
    const downloadDataFlowLetter = async (id: any) => {
        try {
            setLoading(true);

            const response = await getSpecificDetailsById(DOWNLOADDATAFLOWLETTER, id);

            //Check response and download
            if (response) {
                //PDF Download
                const { file_url } = response;
                setLoading(false);

                //PDF Download
                const fileName = `registration-cancellation-letter-${new Date().getTime()}.pdf`;
                const link = document.createElement('a');
                link.href = file_url;
                link.target = '_blank';
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setLoading(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    return (
        <>
            <LettersTab mainTabLabel="Data Flow" />
            <DataFlowLetterTab initialTabLabel="Data Flow Letter" />
            <Toast ref={toast} />
            <div className="grid crud-demo mt-2">
                <div className="col-12">
                    <div className="card">
                        <div className="p-fluid formgrid grid align-items-center">
                            <div className="field col-12 md:col-4">
                                <label htmlFor="regNo">
                                    Reg No <span style={{ color: 'red' }}>*</span>
                                </label>
                                <InputText value={!window.cn(regNo) ? regNo : ''} name="regNo" autoComplete="off" placeholder="Enter Reg No." onChange={(e) => setRegNo(e.target.value)} className={errors['regNo'] && 'p-invalid'} />
                                <small className="p-invalid-txt">{errors['regNo']}</small>
                            </div>
                            <div className="field col-12 md:col-1 mt-4">
                                <Button label="Search" className="p-button-primary" onClick={() => getUserDetails()} loading={showLoading} />
                            </div>
                        </div>
                        <hr />
                        <div className="p-fluid formgrid grid">
                            <div className="field col-12 md:col-4">
                                <label htmlFor="Name">Name</label>
                                <InputText value={!window.cn(dataFlowLetterData?.Name) ? dataFlowLetterData?.Name : ''} name="Name" disabled={true} />
                            </div>

                            {/* Letter Date Field */}
                            <div className="field col-12 md:col-4">
                                <label htmlFor="letter_date">
                                    Letter Date <span style={{ color: 'red' }}>*</span>
                                </label>
                                <Calendar value={dataFlowLetterData?.letter_date} dateFormat="dd-mm-yy" onChange={(e: any) => onInputChange(e.value, 'letter_date')} showIcon className={errors['letter_date'] && 'p-invalid'} />
                                <small className="p-invalid-txt">{errors['letter_date']}</small>
                            </div>

                            {/* Good Standing Date Field */}
                            <div className="field col-12 md:col-4">
                                <label htmlFor="goodstanding_date">
                                    Good Standing Date <span style={{ color: 'red' }}>*</span>
                                </label>
                                <Calendar value={dataFlowLetterData?.goodstanding_date} dateFormat="dd-mm-yy" onChange={(e: any) => onInputChange(e.value, 'goodstanding_date')} showIcon className={errors['goodstanding_date'] && 'p-invalid'} />
                                <small className="p-invalid-txt">{errors['goodstanding_date']}</small>
                            </div>

                        </div>
                        <div className="formgrid grid">
                            <div className="field col-12 md:col-12">
                                <div style={{ display: 'flex', float: 'right', gap: 4 }}>
                                    <Button label="Clear" icon="pi pi-times" className="p-button-secondary mr-2" onClick={() => clearAll()} />
                                    <Button label="Save" icon="pi pi-check" onClick={() => addDataFlowLetterData()} loading={addLoader} disabled={buttonVisible} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={dataFlowLetterList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    rows={defaultRowOptions}
                                    paginator={dataFlowLetterList.length >= 10 && true}
                                    rowsPerPageOptions={defaultPageRowOptions}
                                    className="datatable-responsive p-datatable-sm"
                                    emptyMessage="No Data Found"
                                    removableSort
                                >
                                    {DataFlowListColumns.map((col, i) => {
                                        if (col.field === 'action') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={actionsTemplate} />;
                                        } else if (col.field === 'created_at') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={dateTemplate} />;
                                        } else if (col.field === 'goodstanding_date') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={dateTemplate} />;
                                        } else if (col.field === 'letter_date') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={dateTemplate} />;
                                        } else if (col.field === 'amount') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={amountTemplate} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {DataFlowListColumns.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>

            {loading === true ? <Loader /> : ''}

        </>
    );
};
